import script from "./UserTag.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTag.vue?vue&type=script&setup=true&lang=js"

import "./UserTag.vue?vue&type=style&index=0&id=5198a0c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5198a0c8"]])

export default __exports__